import { State } from '../reducers/rootReducer'
import { PrStringStatusDataState } from '../reducers/prStringStatusDataReducer'

const prStringStatusDataSelector = (state: State): PrStringStatusDataState => state.prStringStatus

export default prStringStatusDataSelector
